/*
  Fecha de entrega estimada del carrito (lateral + página). Todo el cálculo
  vive aquí, nunca en Liquid — ver la nota en
  snippets/mundomantel-delivery-estimate.liquid sobre por qué (el HTML del
  carrito puede venir de una respuesta cacheada/fetch antigua).

  Aislamiento: esto solo actúa sobre [data-mm-delivery-estimate]; si esa caja
  no existe en la página (o el ajuste "Mostrar la fecha de entrega estimada"
  está desactivado, en cuyo caso el snippet ni la pinta), este script no hace
  nada.
*/
(function () {
  if (window.__mmDeliveryBound) return;
  window.__mmDeliveryBound = true;

  var ZONA = 'Europe/Madrid';

  // --- Reloj de Madrid, independiente de la zona horaria del dispositivo ---
  // Se extraen año/mes/día/hora/minuto TAL COMO SE VEN EN MADRID (vía Intl,
  // que ya hace la conversión de zona horaria correctamente, DST incluido) y
  // se reconstruyen como un Date "local" con esos mismos números. A partir de
  // ahí, toda la aritmética de este archivo usa SIEMPRE getters locales
  // (getDate/getDay/getHours...) sobre ese objeto — nunca se compara contra
  // UTC ni contra la hora real del dispositivo, así que el resultado es el
  // mismo para un cliente en Madrid, Canarias o América.
  function ahoraMadrid() {
    if (window.__mmDeliveryTestNow) return new Date(window.__mmDeliveryTestNow.getTime());
    var fmt = new Intl.DateTimeFormat('en-CA', {
      timeZone: ZONA,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    });
    var partes = {};
    fmt.formatToParts(new Date()).forEach(function (p) {
      partes[p.type] = p.value;
    });
    return new Date(
      parseInt(partes.year, 10),
      parseInt(partes.month, 10) - 1,
      parseInt(partes.day, 10),
      parseInt(partes.hour, 10) === 24 ? 0 : parseInt(partes.hour, 10),
      parseInt(partes.minute, 10),
      parseInt(partes.second, 10)
    );
  }

  function soloFecha(d) {
    return new Date(d.getFullYear(), d.getMonth(), d.getDate());
  }

  function sumarDias(d, n) {
    var r = new Date(d.getTime());
    r.setDate(r.getDate() + n);
    return r;
  }

  function aYMD(d) {
    var m = String(d.getMonth() + 1).padStart(2, '0');
    var dd = String(d.getDate()).padStart(2, '0');
    return d.getFullYear() + '-' + m + '-' + dd;
  }

  function esLaborable(d, festivos) {
    var dow = d.getDay();
    if (dow === 0 || dow === 6) return false;
    return festivos.indexOf(aYMD(d)) === -1;
  }

  function siguienteLaborable(d, festivos) {
    var r = sumarDias(soloFecha(d), 1);
    while (!esLaborable(r, festivos)) r = sumarDias(r, 1);
    return r;
  }

  function sumarDiasLaborables(d, n, festivos) {
    var r = soloFecha(d);
    var contados = 0;
    while (contados < n) {
      r = sumarDias(r, 1);
      if (esLaborable(r, festivos)) contados++;
    }
    return r;
  }

  // Se arma a mano a partir de formatToParts() (en vez de .format() directo)
  // porque Intl, en es-ES, intercala una coma entre el día de la semana y el
  // grupo "día de mes" cuando se pide el mes largo ("viernes, 6 de
  // noviembre") — formato válido en español, pero no el que se pidió aquí
  // ("viernes 6 de noviembre", sin coma).
  function partesFecha(d, conMes) {
    var opciones = conMes
      ? { weekday: 'long', day: 'numeric', month: 'long' }
      : { weekday: 'long', day: 'numeric' };
    var partes = new Intl.DateTimeFormat('es-ES', opciones).formatToParts(d);
    var obj = {};
    partes.forEach(function (p) {
      if (p.type !== 'literal') obj[p.type] = p.value;
    });
    return obj;
  }

  function formatearSinMes(d) {
    var p = partesFecha(d, false);
    return p.weekday + ' ' + p.day;
  }

  function formatearConMes(d) {
    var p = partesFecha(d, true);
    return p.weekday + ' ' + p.day + ' de ' + p.month;
  }

  function calcularEntrega(ahora, config) {
    var partesHora = (config.cutoff || '16:00').split(':');
    var cutoffH = parseInt(partesHora[0], 10);
    var cutoffM = parseInt(partesHora[1], 10) || 0;
    if (isNaN(cutoffH)) cutoffH = 16;

    var hoyLaborable = esLaborable(ahora, config.festivos);
    var antesDeCorte = ahora.getHours() < cutoffH || (ahora.getHours() === cutoffH && ahora.getMinutes() < cutoffM);

    var fechaEnvio, variante;
    if (hoyLaborable && antesDeCorte) {
      fechaEnvio = soloFecha(ahora);
      variante = 'hoy';
    } else {
      fechaEnvio = siguienteLaborable(ahora, config.festivos);
      if (hoyLaborable) {
        // Solo retrasado por la hora de corte (no por fin de semana/festivo):
        // "mañana" únicamente si ese día siguiente es, de hecho, el de HOY+1
        // Y es laborable. Un pedido en domingo también cae un día después
        // (el lunes), pero no debe entrar aquí: hoyLaborable ya es false para
        // domingo, así que ese caso siempre acaba en la rama "otro" de abajo.
        var manana = sumarDias(soloFecha(ahora), 1);
        variante = fechaEnvio.getTime() === manana.getTime() ? 'manana' : 'otro';
      } else {
        variante = 'otro';
      }
    }

    var fechaMin = sumarDiasLaborables(fechaEnvio, config.minDias, config.festivos);
    var fechaMax = sumarDiasLaborables(fechaEnvio, config.maxDias, config.festivos);

    var mismoMes = fechaMin.getMonth() === fechaMax.getMonth() && fechaMin.getFullYear() === fechaMax.getFullYear();

    return {
      variante: variante,
      cutoff: config.cutoff,
      shipTexto: formatearSinMes(fechaEnvio),
      minTexto: mismoMes ? formatearSinMes(fechaMin) : formatearConMes(fechaMin),
      maxTexto: formatearConMes(fechaMax),
      // Fechas en crudo (no solo el texto ya formateado): las necesita la
      // línea 1 para decidir si mostrar un único día ("Entrega jueves 23 de
      // octubre") o un rango ("Entrega martes 27 – miércoles 28 de
      // octubre"). No cambia nada de lo que ya se calculaba arriba, solo
      // expone dos valores que esta función ya tenía internamente.
      fechaMinTime: fechaMin.getTime(),
      fechaMaxTime: fechaMax.getTime(),
    };
  }

  // Minutos que faltan hasta la hora de corte configurada, contados desde
  // "ahora" (el mismo reloj de Madrid que usa calcularEntrega). Vive aparte
  // de calcularEntrega a propósito: no toca su cálculo de días/festivos, solo
  // reutiliza la MISMA hora de corte ya configurada para la cuenta atrás.
  function minutosHastaCorte(ahora, cutoffStr) {
    var partesHora = (cutoffStr || '16:00').split(':');
    var cutoffH = parseInt(partesHora[0], 10);
    var cutoffM = parseInt(partesHora[1], 10) || 0;
    if (isNaN(cutoffH)) cutoffH = 16;
    var corte = new Date(ahora.getFullYear(), ahora.getMonth(), ahora.getDate(), cutoffH, cutoffM, 0);
    return Math.floor((corte.getTime() - ahora.getTime()) / 60000);
  }

  // "2 h 15 min" / "45 min" / "6 h" (sin minutos cuando son 0 y hay horas).
  // Sin segundos a propósito (se actualiza una vez por minuto, no por
  // segundo) — ver la nota de accesibilidad/anti-parpadeo en
  // snippets/mundomantel-delivery-estimate.liquid.
  function formatearCuentaAtras(minutosTotales) {
    var horas = Math.floor(minutosTotales / 60);
    var minutos = minutosTotales % 60;
    if (horas > 0) {
      return minutos > 0 ? horas + ' h ' + minutos + ' min' : horas + ' h';
    }
    return minutos + ' min';
  }

  function rellenarPlantilla(plantilla, datos) {
    var resultado = plantilla
      .replace(/\[\[cutoff\]\]/g, datos.cutoff)
      .replace(/\[\[min_date\]\]/g, datos.minTexto)
      .replace(/\[\[max_date\]\]/g, datos.maxTexto)
      .replace(/\[\[ship_date\]\]/g, datos.shipTexto);
    if (datos.countdown !== undefined) {
      resultado = resultado.replace(/\[\[countdown\]\]/g, datos.countdown);
    }
    if (datos.missing !== undefined) {
      resultado = resultado.replace(/\[\[missing\]\]/g, datos.missing);
    }
    if (datos.scope !== undefined) {
      resultado = resultado.replace(/\[\[scope\]\]/g, datos.scope);
    }
    return resultado;
  }

  function leerFestivos(wrap) {
    return (wrap.dataset.holidays || '')
      .split('\n')
      .map(function (s) {
        return s.trim();
      })
      .filter(Boolean);
  }

  function actualizarBloque(wrap) {
    var linea1El = wrap.querySelector('[data-mm-delivery-line1]');
    var linea2El = wrap.querySelector('[data-mm-delivery-line2]');
    if (!linea1El || !linea2El) return;
    try {
      var config = {
        cutoff: wrap.dataset.cutoff || '16:00',
        minDias: parseInt(wrap.dataset.minDays, 10) || 2,
        maxDias: parseInt(wrap.dataset.maxDays, 10) || 3,
        festivos: leerFestivos(wrap),
      };
      var datos = calcularEntrega(ahoraMadrid(), config);

      // Línea 1: un único día si la entrega mínima y máxima coinciden
      // ("Entrega jueves 23 de octubre"), o un rango si no ("Entrega martes
      // 27 – miércoles 28 de octubre" / "Entrega viernes 30 de octubre –
      // lunes 2 de noviembre" si cruza de mes — ambos casos ya los arma
      // calcularEntrega() tal cual, sin tocar nada aquí).
      var mismaFecha = datos.fechaMinTime === datos.fechaMaxTime;
      var plantillaLinea1 = mismaFecha ? wrap.dataset.textLine1Single : wrap.dataset.textLine1Range;

      // Línea 2: cuenta atrás en vivo solo si el pedido puede salir HOY.
      var plantillaLinea2;
      if (datos.variante === 'hoy') {
        var minutosRestantes = minutosHastaCorte(ahoraMadrid(), config.cutoff);
        // "Menos de 1 minuto" se trata como <= 1 minuto completo restante:
        // con la función de prueba (que no admite segundos) forzar p. ej.
        // las 15:59 dejaría siempre exactamente 1 minuto exacto hasta las
        // 16:00, y ese instante debe mostrar ya "Pide ahora", no "1 min".
        if (minutosRestantes <= 1) {
          plantillaLinea2 = wrap.dataset.textLine2TodayNow;
        } else {
          plantillaLinea2 = wrap.dataset.textLine2TodayCountdown;
          datos.countdown = formatearCuentaAtras(minutosRestantes);
        }
      } else if (datos.variante === 'manana') {
        plantillaLinea2 = wrap.dataset.textLine2Tomorrow;
      } else {
        plantillaLinea2 = wrap.dataset.textLine2Later;
      }

      if (!plantillaLinea1 || !plantillaLinea2) throw new Error('mm-delivery-estimate: falta la plantilla de texto');
      linea1El.innerHTML = rellenarPlantilla(plantillaLinea1, datos);
      linea2El.innerHTML = rellenarPlantilla(plantillaLinea2, datos);
    } catch (e) {
      linea1El.textContent = wrap.dataset.textFallback || 'Llega en 48–72 horas.';
      linea2El.textContent = '';
    }
  }

  // --- Línea 3 (envío gratis) — solo en los bloques del carrito/aviso ---
  // En la ficha de producto la línea 3 es un texto estático ya resuelto por
  // Liquid (no depende del carrito), así que no tiene
  // data-free-shipping-threshold-cents y esta función no hace nada ahí (sale
  // en el primer "return"). En el carrito sí depende del total actual, así
  // que se recalcula en cada "actualizarTodos()" (carga, cada minuto, al
  // abrir el carrito lateral y en cada actualización del carrito) pidiendo
  // /cart.js — el propio endpoint de solo lectura de Shopify, siempre con el
  // total más reciente, sin depender de qué payload concreto publique cada
  // sitio del tema en el evento "cart-update" (varía según si fue un cambio
  // de cantidad, un add-to-cart, etc.).
  // Aplica el money_format configurado en la tienda (Ajustes > General >
  // Formato de moneda), el mismo que ya usa el filtro "money" de Liquid en
  // el resto del tema (p. ej. para el mensaje estático de la ficha de
  // producto) — así los dos sitios muestran el importe exactamente igual
  // ("€50,00" o "50,00 €" o lo que sea, según tenga configurado el
  // comercio), en vez de un formato genérico aparte inventado para este
  // bloque. Implementa a mano los mismos marcadores {{amount...}} que usa
  // Shopify en ese ajuste porque esto corre en el navegador, donde no hay
  // filtros de Liquid disponibles.
  function aplicarFormatoMoneda(formato, centavos) {
    var conPunto = (centavos / 100).toFixed(2);
    var sinDecimales = String(Math.round(centavos / 100));
    var conComa = conPunto.replace('.', ',');
    return formato
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, sinDecimales)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, conComa)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, sinDecimales)
      .replace(/\{\{\s*amount\s*\}\}/g, conPunto);
  }

  function formatearImporte(centavos, formatoMoneda) {
    if (formatoMoneda) {
      try {
        var resultado = aplicarFormatoMoneda(formatoMoneda, centavos);
        if (resultado !== formatoMoneda) return resultado;
      } catch (e) {
        /* sigue al formato de respaldo */
      }
    }
    return (centavos / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function actualizarEnvioGratis(wrap) {
    var thresholdCents = parseInt(wrap.dataset.freeShippingThresholdCents, 10);
    if (!thresholdCents) return;
    var linea3El = wrap.querySelector('[data-mm-delivery-line3]');
    if (!linea3El) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (respuesta) {
        return respuesta.json();
      })
      .then(function (carrito) {
        var plantilla, datos;
        if (carrito.total_price >= thresholdCents) {
          plantilla = wrap.dataset.textLine3CartReached;
          datos = { scope: wrap.dataset.scope || '' };
        } else {
          plantilla = wrap.dataset.textLine3CartBelow;
          datos = {
            scope: wrap.dataset.scope || '',
            missing: formatearImporte(thresholdCents - carrito.total_price, wrap.dataset.moneyFormat),
          };
        }
        if (!plantilla) return;
        linea3El.innerHTML = rellenarPlantilla(plantilla, datos);
      })
      .catch(function () {
        // Si falla el fetch, se deja el mensaje estático que ya pintó
        // Liquid ("Envío gratis a partir de X€") — sigue siendo correcto,
        // solo no refleja el total exacto del carrito en ese momento.
      });
  }

  function actualizarTodos() {
    document.querySelectorAll('[data-mm-delivery-estimate]').forEach(function (wrap) {
      actualizarBloque(wrap);
      actualizarEnvioGratis(wrap);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', actualizarTodos);
  } else {
    actualizarTodos();
  }

  // El carrito reemplaza su propio HTML (fetch) al añadir/quitar/cambiar
  // cantidades — hay que recalcular cada vez que eso pasa, no solo al cargar
  // la página. Ver assets/cart.js / assets/product-form.js: ambos publican
  // este evento tras cada actualización, con el carrito ya resuelto.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      // El reemplazo del HTML es asíncrono; un margen pequeño asegura que la
      // caja ya esté en el DOM cuando se recalcula.
      setTimeout(actualizarTodos, 50);
    });
  }

  // "Recalcula al abrir el carrito lateral": el tema no emite ningún evento
  // propio para esto (<cart-drawer>.open() solo añade la clase "active"), así
  // que se observa ese único cambio real y observable.
  var cartDrawerEl = document.querySelector('cart-drawer');
  if (cartDrawerEl && window.MutationObserver) {
    var observador = new MutationObserver(function (mutaciones) {
      for (var i = 0; i < mutaciones.length; i++) {
        if (mutaciones[i].attributeName === 'class' && cartDrawerEl.classList.contains('active')) {
          actualizarTodos();
          break;
        }
      }
    });
    observador.observe(cartDrawerEl, { attributes: true, attributeFilter: ['class'] });
  }

  // Revisa cada minuto por si cambia la hora de corte, el día, la cuenta
  // atrás o el total del carrito mientras la pestaña sigue abierta. Se
  // pausa cuando la pestaña no está visible (Page Visibility API) para no
  // gastar recursos de fondo ni desincronizar la cuenta atrás, y se
  // recalcula una vez al momento al volver a primer plano en vez de esperar
  // hasta el siguiente minuto.
  var mmIntervalId = null;
  function iniciarIntervaloDelivery() {
    if (mmIntervalId) return;
    mmIntervalId = setInterval(actualizarTodos, 60000);
  }
  function detenerIntervaloDelivery() {
    if (!mmIntervalId) return;
    clearInterval(mmIntervalId);
    mmIntervalId = null;
  }
  iniciarIntervaloDelivery();
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      detenerIntervaloDelivery();
    } else {
      actualizarTodos();
      iniciarIntervaloDelivery();
    }
  });

  window.__mmDeliveryRecalc = actualizarTodos;

  // --- Visibilidad por variante (solo el bloque de la ficha de producto) ---
  // Las fechas no dependen de la variante elegida (misma hora de corte,
  // mismos días, mismos festivos para todo el producto), así que aquí NO
  // hay que recalcular nada: basta con mostrar/ocultar la tarjeta ya pintada
  // cuando la variante seleccionada está agotada o no disponible. El bloque
  // del carrito nunca tiene data-section, así que este código no le afecta
  // en absoluto (el querySelector de abajo simplemente no encuentra nada).
  // Escucha el mismo evento "variant-change" que ya publica
  // assets/global.js tras cada cambio de variante — sin tocar esa lógica.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      if (!event.data || !event.data.sectionId) return;
      var wrap = document.querySelector('[data-mm-delivery-estimate][data-section="' + event.data.sectionId + '"]');
      if (!wrap) return;
      var disponible = !!(event.data.variant && event.data.variant.available);
      wrap.classList.toggle('mm-delivery-estimate--hidden', !disponible);
    });
  }

  /*
    Función de prueba — inactiva en producción salvo que alguien la llame a
    propósito desde la consola del navegador. Fuerza la hora "de Madrid" a un
    valor exacto (año, mes 1-12, día, hora 0-23, minuto), sin depender de la
    zona horaria real del dispositivo que la ejecuta, y recalcula al momento.
    Llamar sin argumentos quita el forzado y vuelve a la hora real.

    Ejemplos:
      mmDeliveryTest(2026, 10, 20, 10, 0)   // martes 10:00
      mmDeliveryTest(2026, 10, 20, 16, 30)  // martes 16:30
      mmDeliveryTest()                      // vuelve a la hora real
  */
  window.mmDeliveryTest = function (anio, mes, dia, hora, minuto) {
    if (arguments.length === 0) {
      window.__mmDeliveryTestNow = null;
    } else {
      window.__mmDeliveryTestNow = new Date(anio, mes - 1, dia, hora || 0, minuto || 0, 0);
    }
    actualizarTodos();
    return window.__mmDeliveryTestNow;
  };
})();
